var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"projects"}},[_c('Project1'),_c('Project2'),_c('Project3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }